import { SourceDictionary } from "@/models/legislation/LegislationFilter";
import { createContext, useContext } from "react";

export type DefaultsPlan = {
  sourceKey: string;
  childFilters: { id: string; value: unknown }[];
} | null;
export interface LegislationFilterConfigContextValue {
  filterConfig: SourceDictionary | undefined;
  defaultsPlan: DefaultsPlan;
  isLoading: boolean;
}

export const LegislationFilterConfigContext = createContext<
  LegislationFilterConfigContextValue | undefined
>(undefined);

const useLegislationFilterConfigContext = () => {
  const context = useContext(LegislationFilterConfigContext);
  if (!context) {
    throw new Error(
      "useLegislationFilterConfigContext must be used within LegislationFilterConfigProvider"
    );
  }
  return context;
};
export const useLegislationFilterConfig = () => {
  return useLegislationFilterConfigContext();
};
